import { Input, Select } from "antd";
export const disputeOverviewTableColumns = (customerUidData, logisticsService) => {
    return [
        {
            title: 'Tracking Number',
            dataIndex: ['billing_detail', 'tracking_id'],
            key: 'tracking_id',
            fixed: 'left',
            search: true,
            renderFormItem: (item, { type, defaultRender, ...rest }) => {
                return <Input placeholder="请输入(支持模糊查询)" allowClear />
            },
        },
        {
            title: 'UID',
            dataIndex: ['billing_detail', 'customer', 'uid'],
            key: 'uid',
            fixed: 'left',
            search: true,
            renderFormItem: (item, { type, defaultRender, ...rest }) => {
                return <Select
                    showSearch
                    allowClear
                    placeholder="请选择"
                    filterOption={(input, option) => {
                        return option.label.toLowerCase().includes(input.toLowerCase());
                    }}
                    optionFilterProp="children"
                    options={
                        customerUidData?.map((item) => {
                            return {
                                label: item.uid,
                                value: item.id,
                            }
                        })
                    }
                    style={{
                        textAlign: 'left',
                    }}
                    />
            },
        },
        {
            title: 'Dispute Date',
            dataIndex: 'dispute_date',
            key: 'dispute_date',
            fixed: 'left',
            search: false,
        },
        {
            title: '导入批次编号',
            dataIndex: ['billing_invoice', 'name'],
            key: 'billing_invoice_name',
            search: true,
            renderFormItem: (item, { type, defaultRender, ...rest }) => {
                return <Input placeholder="请输入(支持模糊查询)" allowClear />
            },
        },
        {
            title: 'Master EDI Number',
            dataIndex: ['billing_detail', 'rate_json', 'Master EDI No'],
            key: 'master_edi_number',
            search: false,
        },
        {
            title: 'Invoice Number',
            dataIndex: ['billing_detail', 'invoice_number'],
            key: 'invoice_number',
            search: false,
        },
        {
            title: 'Invoice Date',
            dataIndex: ['billing_detail', 'invoice_date'],
            key: 'invoice_date',
            search: false,
        },
        {
            title: 'Total Invoice Charge',
            dataIndex: ['billing_detail', 'rate_json', 'Inv Charge'],
            key: 'Invoice Charge',
            search: false,
        },
        {
            title: 'Bill to Account Number',
            dataIndex: ['billing_detail', 'rate_json', 'Bill-to Account'],
            key: 'bill_to_account_number',
            search: false,
        },
        {
            title: 'Bill to country',
            dataIndex: ['billing_detail', 'rate_json', 'Cntry'],
            key: 'bill_to_country',
            search: false,
        },
        {
            title: 'Company Code',
            dataIndex: ['billing_detail', 'rate_json', 'Co.Cd'],
            key: 'company_code',
            search: false,
        },
        {
            title: 'Ground Tracking ID Prefix',
            dataIndex: ['billing_detail', 'rate_json', 'Grd Prefix'],
            key: 'ground_tracking_id_prefix',
            search: false,
        },
        {
            title: 'Shipment Date',
            dataIndex: ['billing_detail', 'shipment_date'],
            key: 'shipment_date',
            search: false,
        },
        {
            title: 'Service',
            dataIndex: ['billing_detail', 'logistics_service', 'name'],
            key: 'logistics_service',
            search: true,
            renderFormItem: (item, { type, defaultRender, ...rest }) => {
                return <Select
                    showSearch
                    allowClear
                    placeholder="请选择"
                    filterOption={(input, option) => {
                        return option.label.toLowerCase().includes(input.toLowerCase());
                    }}
                    optionFilterProp="children"
                    options={
                        logisticsService?.map((item) => {
                            return {
                                label: item.name,
                                value: item.id,
                            }
                        })
                    }
                    style={{
                        textAlign: 'left',
                    }}
                    />
            },
        },
        {
            title: 'Ground Service',
            dataIndex: ['billing_detail', 'rate_json', 'Grd Svc'],
            key: 'ground_service',
            search: false,
        },
        {
            title: 'Reference 1',
            dataIndex: ['billing_detail', 'rate_json', 'Ref 1'],
            key: 'ref_1',
            search: false,
        },
        {
            title: 'Reference 2',
            dataIndex: ['billing_detail', 'rate_json', 'Ref 2'],
            key: 'ref_2',
            search: false,
        },
        {
            title: 'Reference 3',
            dataIndex: ['billing_detail', 'rate_json', 'Ref 3'],
            key: 'ref_3',
            search: false,
        },
        {
            title: 'Customer Department Number',
            dataIndex: ['billing_detail', 'rate_json', 'Grd Dept No'],
            key: 'grd_dept_no',
            search: false,
        },
        {
            title: 'Net Charge',
            dataIndex: ['billing_detail', 'rate_json', 'Net Chrg'],
            key: 'net_charge',
            search: false,
        },
        {
            title: 'Currency',
            dataIndex: ['billing_detail', 'rate_json', 'Curr'],
            key: 'currency',
            search: false,
        },
        {
            title: 'Charge 1',
            dataIndex: ['billing_detail', 'rate_json', 'Chrg 1'],
            key: 'chrg_1',
            search: false,
        },
        {
            title: 'Freight Amount',
            dataIndex: ['billing_detail', 'rate_json', 'Freight Amt'],
            key: 'freight_amount',
            search: false,
        },
        {
            title: 'Scale',
            dataIndex: ['billing_detail', 'rate_json', 'Scale'],
            key: 'scale',
            search: false,
        },
        {
            title: 'Pieces',
            dataIndex: ['billing_detail', 'rate_json', 'Pcs'],
            key: 'Pcs',
            search: false,
        },
        {
            title: 'Bill Weight',
            dataIndex: ['billing_detail', 'rate_json', 'Bill Wt'],
            key: 'bill_weight',
            search: false,
        },
        {
            title: 'Original Weight',
            dataIndex: ['billing_detail', 'rate_json', 'Orig Wt'],
            key: 'original_weight',
            search: false,
        },
        {
            title: 'Multi-Weight',
            dataIndex: ['billing_detail', 'rate_json', 'Multi-Wt'],
            key: 'multi_weight',
            search: false,
        },
        {
            title: 'weight unit',
            dataIndex: ['billing_detail', 'rate_json', 'Wt Unit'],
            key: 'weight_unit',
            search: false,
        },
        {
            title: 'Length',
            dataIndex: ['billing_detail', 'rate_json', 'Length'],
            key: 'length',
            search: false,
        },
        {
            title: 'Width',
            dataIndex: ['billing_detail', 'rate_json', 'Width'],
            key: 'width',
            search: false,
        },
        {
            title: 'Height',
            dataIndex: ['billing_detail', 'rate_json', 'Height'],
            key: 'height',
            search: false,
        },
        {
            title: 'Dimension Unit',
            dataIndex: ['billing_detail', 'rate_json', 'Dim Unit'],
            key: 'dimension_unit',
            search: false,
        },
        {
            title: 'Divisor',
            dataIndex: ['billing_detail', 'rate_json', 'Divisor'],
            key: 'divisor',
            search: false,
        },
        {
            title: 'Ground Miscellaneous Description 1',
            dataIndex: ['billing_detail', 'rate_json', 'Grd Misc 1'],
            key: 'grd_misc_desc_1',
            search: false,
        },
        {
            title: 'Ground Miscellaneous Description 2',
            dataIndex: ['billing_detail', 'rate_json', 'Grd Misc 2'],
            key: 'grd_misc_desc_2',
            search: false,
        },
        {
            title: 'Ground Miscellaneous Description 3',
            dataIndex: ['billing_detail', 'rate_json', 'Grd Misc 3'],
            key: 'grd_misc_desc_3',
            search: false,
        },
        {
            title: 'Shipper Name',
            dataIndex: ['billing_detail', 'rate_json', 'Shipper Name'],
            key: 'shipper_name',
            search: false,
        },
        {
            title: 'Shipper Company',
            dataIndex: ['billing_detail', 'rate_json', 'Shipper Company'],
            key: 'shipper_company',
            search: false,
        },
        {
            title: 'Shipper Dept',
            dataIndex: ['billing_detail', 'rate_json', 'Shipper Dept'],
            key: 'shipper_dept',
            search: false,
        },
        {
            title: 'Shipper Address 1',
            dataIndex: ['billing_detail', 'rate_json', 'Shipper Address 1'],
            key: 'shipper_addr1',
            search: false,
        },
        {
            title: 'Shipper Address 2',
            dataIndex: ['billing_detail', 'rate_json', 'Shipper Address 2'],
            key: 'shipper_addr2',
            search: false,
        },
        {
            title: 'Shipper City',
            dataIndex: ['billing_detail', 'rate_json', 'Shipper City'],
            key: 'shipper_city',
            search: false,
        },
        {
            title: 'ST',
            dataIndex: ['billing_detail', 'rate_json', 'ST'],
            key: 'shipper_st',
            search: false,
        },
        {
            title: 'Postal',
            dataIndex: ['billing_detail', 'rate_json', 'Postal'],
            key: 'postal',
            search: false,
        },
        {
            title: 'US Origin',
            dataIndex: ['billing_detail', 'rate_json', 'US Origin'],
            key: 'us_origin',
            search: false,
        },
        {
            title: 'Cntry1',
            dataIndex: ['billing_detail', 'rate_json', 'Cntry1'],
            key: 'cntry1',
            search: false,
        },
        {
            title: 'Region',
            dataIndex: ['billing_detail', 'rate_json', 'Region'],
            key: 'region',
            search: false,
        },
        {
            title: 'Recipient Name',
            dataIndex: ['billing_detail', 'rate_json', 'Recipient Name'],
            key: 'recipient_name',
            search: false,
        },
        {
            title: 'Recipient Company',
            dataIndex: ['billing_detail', 'rate_json', 'Recipient Company'],
            key: 'recipient_company',
            search: false,
        },
        {
            title: 'Recipient Address 1',
            dataIndex: ['billing_detail', 'rate_json', 'Recipient Address 1'],
            key: 'recipient_addr1',
            search: false,
        },
        {
            title: 'Recipient Address 2',
            dataIndex: ['billing_detail', 'rate_json', 'Recipient Address 2'],
            key: 'recipient_addr2',
            search: false,
        },
        {
            title: 'Recipient City',
            dataIndex: ['billing_detail', 'rate_json', 'Recipient City'],
            key: 'recipient_city',
            search: false,
        },
        {
            title: 'ST2',
            dataIndex: ['billing_detail', 'rate_json', 'ST2'],
            key: 'recipient_st',
            search: false,
        },
        {
            title: 'Postal2',
            dataIndex: ['billing_detail', 'rate_json', 'Postal2'],
            key: 'recipient_postal',
            search: false,
        },
        {
            title: 'Cntry2',
            dataIndex: ['billing_detail', 'rate_json', 'Cntry2'],
            key: 'recipient_country',
            search: false,
        },
        {
            title: 'Hndlg',
            dataIndex: ['billing_detail', 'rate_json', 'Hndlg'],
            key: 'hndlg',
            search: false,
        },
        {
            title: 'Dlvry Date',
            dataIndex: ['billing_detail', 'rate_json', 'Dlvry Date'],
            key: 'dlvry_date',
            search: false,
        },
        {
            title: 'Time',
            dataIndex: ['billing_detail', 'rate_json', 'Time'],
            key: 'time',
            search: false,
        },
        {
            title: 'Final',
            dataIndex: ['billing_detail', 'rate_json', 'Final'],
            key: 'final',
            search: false,
        },
        {
            title: 'Exceptn',
            dataIndex: ['billing_detail', 'rate_json', 'Exceptn'],
            key: 'exceptn',
            search: false,
        },
        {
            title: 'Attempt Date',
            dataIndex: ['billing_detail', 'rate_json', 'Attempt Date'],
            key: 'attempt_date',
            search: false,
        },
        {
            title: 'Attempt Time',
            dataIndex: ['billing_detail', 'rate_json', 'Attempt Time'],
            key: 'attempt_time',
            search: false,
        },
        {
            title: 'Signature',
            dataIndex: ['billing_detail', 'rate_json', 'Signature'],
            key: 'signature',
            search: false,
        },
        {
            title: 'Svc Area',
            dataIndex: ['billing_detail', 'rate_json', 'Svc Area'],
            key: 'svc_area',
            search: false,
        },
        {
            title: 'Orig Recip Adr 1',
            dataIndex: ['billing_detail', 'rate_json', 'Orig Recip Adr 1'],
            key: 'orig_recip_adr_1',
            search: false,
        },
        {
            title: 'Orig Recip Adr 2',
            dataIndex: ['billing_detail', 'rate_json', 'Orig Recip Adr 2'],
            key: 'orig_recip_adr_2',
            search: false,
        },
        {
            title: 'Original City',
            dataIndex: ['billing_detail', 'rate_json', 'Original City'],
            key: 'orig_city',
            search: false,
        },
    ]
}
